import { DocumentCategoryIcon, DocumentCategoryKeys } from '../../model/DocumentCategory'
import { useMemo } from 'react'
import { SelectOption } from '../../model/SelectOption'
import { useGetDocumentCategories } from '../queries/documentCategories'
import { type IconsType } from '../../components/shared'
import { ColorsV2 } from '../../design-system/colors_v2'
import { isValidColorType, isValidIconType } from '../../misc/documentCategory.utilities'
import { getDefaultBgColor } from '../../misc/colors.utilities'

export const useDocumentCategoryOptions = (): Array<SelectOption<DocumentCategoryKeys>> => {
  const { documentCategories } = useGetDocumentCategories()

  return useMemo(
    () =>
      documentCategories
        .filter(({ id }) => id !== DocumentCategoryKeys.Survey)
        .map(({ id, label, color, icon }) => ({
          value: id,
          label,
          icon: isValidIconType(icon) ? (icon as IconsType) : DocumentCategoryIcon[id],
          color: isValidColorType(color as ColorsV2) ? (color as ColorsV2) : getDefaultBgColor(),
        })),
    [documentCategories],
  )
}
